// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__TLBSr","row":"styles_row__oDmqW","item":"styles_item__vY9NG"};